import React from 'react';
import ToastMessage from './../../../components/shared/Toasts';

const preferenceSaveErrorMessage = (
    <ToastMessage icon="exclamation">
        <div id="preference-error">
            Something Appears to be Wrong. <br />
            Contact us through the mail icon on the bottom of the screen for assistance
        </div>
    </ToastMessage>
);

const preferenceSaveSuccessMessage = (
    <ToastMessage icon="check">
        <div id="preference-save">Default Submission Save Successfully</div>
    </ToastMessage>
);

/* eslint-disable */

const defaultSubmissionMessage = callback => () => {
    return (
        <ToastMessage icon="check">
            <div id="preference-default">
                You've been emailed an updated pricing summary for Owner's Interest . <br />
                <u onClick={callback}>Save coverage selection as default</u> 
                <br/>
                Quote and policy specimen are available for download from the submission list.
            </div>
        </ToastMessage>
    );
};

/* eslint-disable */
const preferenceInfoMsg = (callback) => {
    return (
        <ToastMessage icon="check">
            These coverages were selected based on your default preferences<br />
            <u onClick={callback}>Remove preferences</u> 
        </ToastMessage>
    );
};


export default {
    preferenceSaveErrorMessage,
    preferenceSaveSuccessMessage,
    preferenceInfoMsg,
    defaultSubmissionMessage
};
